// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aBwMs","footer":"styles_footer__2ywd6"};